import {Image} from 'antd'
import normalizeUrl from '@/biz/normalizeUrl.mjs'
import useExistedUrl from '@/hooks/useExistedUrl.mjs'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

const PropertiesControllerThumb = (props) => {
    const [{fileId}] = useProperties()

    if (! fileId) {
        return null
    }

    const src = useExistedUrl(
        fileId && normalizeUrl(`/files/${fileId}`)
    )

    if (! src) {
        return null
    }

    return (
        <Image
            src={src}
            {...props}
        />
    )
}

export default PropertiesControllerThumb
